var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"placeholder":"Offer title","fetch-suggestions":_vm.searchDeal,"debounce":500,"trigger-on-focus":false,"value":"dealId","value-key":"title"},on:{"select":_vm.onSelect},model:{value:(_vm.deal),callback:function ($$v) {_vm.deal=$$v},expression:"deal"}},[_c('i',{staticClass:"el-icon-search el-input__icon",attrs:{"slot":"suffix"},slot:"suffix"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c06f71d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/happypack/loader.js?id=eslint!./src/app/components/deal/Search.vue
// module id = 704
// module chunks = 1